import React from 'react';
import PropTypes from 'prop-types';


const WindowBrowser = ({ header, description }) => {
  return (
    <div className="box">
      <div className="upper-box">
        <div className="wrapper">
          <div className="btn close-btn" />
          <div className="btn min-btn" />
          <div className="btn max-btn" />
        </div>
      </div>
      <div className="lower-box">
        <div className="header-box">{header}</div>
        <div className="description-box">{description}</div>
      </div>
    </div>
  );
};

WindowBrowser.propTypes = {
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default WindowBrowser;
